// extracted by mini-css-extract-plugin
export default {"Header":"AppSimplePage__Header__8U0Qo","LogoWrapper":"AppSimplePage__LogoWrapper__H-rXh","Sidebar":"AppSimplePage__Sidebar__Ws1Jt","Content":"AppSimplePage__Content__AiMd3"};